<template>
    <div :id="id" class="modal fade text-left"  tabindex="-1" aria-labelledby="video-player" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal(`#${id}`)">
                        <span aria-hidden="true" >×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="videoData.type == 1">
                        <iframe style="margin:auto;height: 66vh;width: 100%;" width="560" height="315" :src="videoData.source" :title="videoData.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div v-else>
                        <vue3-video-player :src="videoData.source"  ref="videocontainer" :title="videoData.title"></vue3-video-player>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { BBadge, BLink, BFormInput, BFormTextarea, BRow, BCol } from "bootstrap-vue-3";
import { ref } from 'vue'
import { closeModal } from '../../utilities/_helpers'

export default{
    name:'videoPlayer',
    components: {
        BBadge,
        BRow,
        BCol,
        BLink,
        BFormInput,
        BFormTextarea,
    },
    props:{
        videoData: {
            type: Object
        },
        id: {
            type: String
        },
    },
    setup(props){
        return{
            closeModal: closeModal
        }
    },
    watch: {
    },
    methods:{
    }
}
</script>
